import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { IDeliveryMethodItem } from "../@types";
import { ErrorResponse } from "../../../requests/@types";
import api from "../../../services/api";
import { show } from "../../../notifications/notifications";
import { NotificationsLevel } from "../../../lib/enums";

const useManageDeliveryMethod = (
  resetValues: () => void,
  deliveryMethodId?: number | null,
  onClose?: () => void
) => {
  const queryClient = useQueryClient();

  const {
    mutate,
    error: submitErrors,
    reset: resetSaveResponse
  } = useMutation<
    AxiosResponse<IDeliveryMethodItem>,
    ErrorResponse,
    IDeliveryMethodItem
  >({
    mutationFn: (data: IDeliveryMethodItem) =>
      deliveryMethodId
        ? api.updateAction(deliveryMethodId, data)
        : api.createAction(data),
    onSuccess: () => {
      show({
        level: NotificationsLevel.SUCCESS,
        message: "Delivery Method successfully saved."
      });
      queryClient.invalidateQueries({ queryKey: ["alertsActionsList"] });
      resetValues();
      onClose?.();
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: "Please correct the Delivery Method Form errors."
      });
    }
  });

  return {
    submit: mutate,
    submitErrors,
    resetSaveResponse
  };
};

export default useManageDeliveryMethod;
